"use strict";

class PropertyDocumentsController {

    constructor($scope, $window, $timeout, $sce, Upload, SSAwsService, SSHttpService, SSUtilService, SSAlertService, SSConfigService, SSAppService, SSUserService, OTPService, SSDateService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$timeout = $timeout;
        self.sce = $sce;

        self.Upload = Upload;
        self.SSAwsService = SSAwsService;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSDateService = SSDateService;

        self.PROPERTY_DOCUMENT_TYPE_FORM = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_FORM;
        self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED;

        self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM;
        self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM;
        self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SIDE_LETTER;
        self.PROPERTY_DOCUMENT_KIND_PDI_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PDI_FORM;
        self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS;
        self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;
        self.PROPERTY_DOCUMENT_KIND_ANNEXES = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEXES;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_A = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_A;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_B3 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_B3;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_C = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_C;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT;
        self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION;
        self.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS;
        self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_LETTER;
        self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM;
        self.PROPERTY_DOCUMENT_KIND_SPA_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SPA_LETTER;
        self.PROPERTY_DOCUMENT_KIND_ICL_BANK_IN = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ICL_BANK_IN;
        self.PROPERTY_DOCUMENT_KIND_BANK_IN_LIST = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BANK_IN_LIST;
        self.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE;
        self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_B = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_B;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_C = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_C;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_D = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_D;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_E = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_E;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_F;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_G = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_G;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORMS_CHECK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORMS_CHECK;
        self.PROPERTY_DOCUMENT_KIND_SALES_NOTE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SALES_NOTE;
        self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION;
        self.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT;
        self.PROPERTY_DOCUMENT_KIND_TAX_INVOICE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_TAX_INVOICE;
        self.PROPERTY_DOCUMENT_KIND_OFFICIAL_RECEIPT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OFFICIAL_RECEIPT;
        self.PROPERTY_DOCUMENT_KIND_CREDIT_NOTE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CREDIT_NOTE;
        self.PROPERTY_DOCUMENT_KIND_OFFICIAL_RECEIPT_GST = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OFFICIAL_RECEIPT_GST; // WEB-3524
        self.PROPERTY_DOCUMENT_KIND_SUBSALE_CONFIRMATION_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SUBSALE_CONFIRMATION_LETTER;

        self.ASSET_MODEL_BUYER_DOCUMENT = SHOWSUITE.ASSET_MODEL_BUYER_DOCUMENT;
        self.ASSET_MODEL_PROPERTY_DOCUMENT = SHOWSUITE.ASSET_MODEL_PROPERTY_DOCUMENT;

        self.PROPERTY_DOCUMENT_FORMAT_PDF = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF;
        self.PROPERTY_DOCUMENT_FORMAT_HTML = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_HTML;
        self.PROPERTY_DOCUMENT_FORMAT_IMG = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_IMG;
        self.PROPERTY_DOCUMENT_FORMAT_HTML_PREVIEW_ONLY = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_HTML_PREVIEW_ONLY;

        self.data = SHOWSUITE.data;
        self.property_id = SHOWSUITE.data.property_id;

        self.UNIT_CATEGORIES_MAP = {
            0: {code: 'XX', name: 'Other', className: 'empty'},
            1: {code: '1BR', name: '1 Bedroom', className: 'bed1'},
            2: {code: '2BR', name: '2 Bedroom', className: 'bed2'},
            3: {code: '3BR', name: '3 Bedroom', className: 'bed3'},
            4: {code: '4BR', name: '4 Bedroom', className: 'bed4'},
            5: {code: '5BR', name: '5 Bedroom', className: 'bed5'},
            6: {code: 'PH', name: 'Penthouse', className: 'ph'},
            7: {code: 'COM', name: 'Commercial', className: 'retail'},
            1000: {code: 'CT', name: 'Corner Terrace', className: 'corner-terrace'},
            2000: {code: 'IT', name: 'Intermediate Terrace', className: 'interlaced-terrace'},
            3000: {code: 'SD', name: 'Semi-Detached', className: 'semi-detached'},
            4000: {code: 'DE', name: 'Detached', className: 'detached'},
            4001: {code: 'SU', name: 'Storage Unit', className: 'retail'},
            4002: {code: 'WH', name: 'Warehouse', className: 'detached'},
        };

        // UNIT_STATUS_DRAFT = 10; // just created not listed
        // UNIT_STATUS_LISTED = 20; // listing and ready for sale to public
        // UNIT_STATUS_RESERVED = 30; // booknow session in-progress
        // UNIT_STATUS_BOOKED = 40; // dealing in process
        // UNIT_STATUS_SOLD = 50;
        // UNIT_STATUS_SPECIAL_RESERVED = 60;// Long time reserved

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        self.MARKETING_SCHEME_APPRECIATION_FEE = SHOWSUITE.MARKETING_SCHEME_APPRECIATION_FEE;
        self.MARKETING_SCHEME_BUYER_REFER_BUYER = SHOWSUITE.MARKETING_SCHEME_BUYER_REFER_BUYER;
        self.MARKETING_SCHEME_EXTERNAL_AGENT = SHOWSUITE.MARKETING_SCHEME_EXTERNAL_AGENT;
        self.MARKETING_SCHEME_JOINT_MARKETING_AGENCY = SHOWSUITE.MARKETING_SCHEME_JOINT_MARKETING_AGENCY;
        self.MARKETING_SCHEME_LOCAL_REFERRAL = SHOWSUITE.MARKETING_SCHEME_LOCAL_REFERRAL;
        self.MARKETING_SCHEME_LOCAL_REFERRAL_WITH_LOYALTY_BUYER = SHOWSUITE.MARKETING_SCHEME_LOCAL_REFERRAL_WITH_LOYALTY_BUYER;
        self.MARKETING_SCHEME_LOYALTY_BUYER = SHOWSUITE.MARKETING_SCHEME_LOYALTY_BUYER;
        self.MARKETING_SCHEME_LOYALTY_BUYER_WITH_EXTERNAL_AGENT = SHOWSUITE.MARKETING_SCHEME_LOYALTY_BUYER_WITH_EXTERNAL_AGENT;
        self.MARKETING_SCHEME_LOYALTY_BUYER_WITH_JOINT_MARKETING_AGENCY = SHOWSUITE.MARKETING_SCHEME_LOYALTY_BUYER_WITH_JOINT_MARKETING_AGENCY;
        self.MARKETING_SCHEME_OVERSEAS_REFERRAL = SHOWSUITE.MARKETING_SCHEME_OVERSEAS_REFERRAL;
        self.MARKETING_SCHEME_OVERSEAS_REFERRAL_WITH_LOYALTY_BUYER = SHOWSUITE.MARKETING_SCHEME_OVERSEAS_REFERRAL_WITH_LOYALTY_BUYER;
        self.MARKETING_SCHEME_STAFF_REFERRAL = SHOWSUITE.MARKETING_SCHEME_STAFF_REFERRAL;
        self.MARKETING_SCHEME_STAFF_PURCHASE = SHOWSUITE.MARKETING_SCHEME_STAFF_PURCHASE;
        self.MARKETING_SCHEME_EN_BLOC_PURCHASE = SHOWSUITE.MARKETING_SCHEME_EN_BLOC_PURCHASE;
        self.MARKETING_SCHEME_LARGE_UNITS = SHOWSUITE.MARKETING_SCHEME_LARGE_UNITS;
        self.MARKETING_SCHEME_VIP = SHOWSUITE.MARKETING_SCHEME_VIP;
        self.MARKETING_SCHEME_AGENT_PURCHASE = SHOWSUITE.MARKETING_SCHEME_AGENT_PURCHASE;

        self.PROPERTY_DOCUMENT_PHASE_EOI = SHOWSUITE.PROPERTY_DOCUMENT_PHASE_EOI;
        self.PROPERTY_DOCUMENT_PHASE_BOOKING = SHOWSUITE.PROPERTY_DOCUMENT_PHASE_BOOKING;
        self.PROPERTY_DOCUMENT_PHASE_OTP = SHOWSUITE.PROPERTY_DOCUMENT_PHASE_OTP;
        self.PROPERTY_DOCUMENT_PHASE_KEY_HANDOVER = SHOWSUITE.PROPERTY_DOCUMENT_PHASE_KEY_HANDOVER;
        
        self.MARKETING_SCHEMES = [
            {'id': self.MARKETING_SCHEME_APPRECIATION_FEE, 'name': 'Appreciation Fee'},
            {'id': self.MARKETING_SCHEME_BUYER_REFER_BUYER, 'name': 'Buyer-Refer-Buyer'},
            {'id': self.MARKETING_SCHEME_EXTERNAL_AGENT, 'name': 'External Agent'},
            {'id': self.MARKETING_SCHEME_JOINT_MARKETING_AGENCY, 'name': 'Joint Marketing Agency'},
            {'id': self.MARKETING_SCHEME_LOCAL_REFERRAL, 'name': 'Local Referral'},
            {
                'id': self.MARKETING_SCHEME_LOCAL_REFERRAL_WITH_LOYALTY_BUYER,
                'name': 'Local Referral with Loyalty Buyer'
            },
            {'id': self.MARKETING_SCHEME_LOYALTY_BUYER, 'name': 'Loyalty Buyer'},
            {
                'id': self.MARKETING_SCHEME_LOYALTY_BUYER_WITH_EXTERNAL_AGENT,
                'name': 'Loyalty Buyer with External Agent'
            },
            {
                'id': self.MARKETING_SCHEME_LOYALTY_BUYER_WITH_JOINT_MARKETING_AGENCY,
                'name': 'Loyalty Buyer with Joint Marketing Agency'
            },
            {'id': self.MARKETING_SCHEME_OVERSEAS_REFERRAL, 'name': 'Overseas Referral'},
            {
                'id': self.MARKETING_SCHEME_OVERSEAS_REFERRAL_WITH_LOYALTY_BUYER,
                'name': 'Overseas Referral with Loyalty Buyer'
            },
            {'id': self.MARKETING_SCHEME_STAFF_REFERRAL, 'name': 'Staff Referral'},
            {'id': self.MARKETING_SCHEME_STAFF_PURCHASE, 'name': 'Staff Purchase'},
            {'id': self.MARKETING_SCHEME_EN_BLOC_PURCHASE, 'name': 'En bloc Purchase'},
            {'id': self.MARKETING_SCHEME_LARGE_UNITS, 'name': 'Large units Purchase'},
            {'id': self.MARKETING_SCHEME_VIP, 'name': 'VIP Purchase'},
            {'id': self.MARKETING_SCHEME_AGENT_PURCHASE, 'name': 'Agent Purchase'},
        ];

        self.propertyDocumentPhaseIndicators = [
            {id: self.PROPERTY_DOCUMENT_PHASE_EOI, name: 'EOI'},
            {id: self.PROPERTY_DOCUMENT_PHASE_BOOKING, name: 'BOOKING'},
            {id: self.PROPERTY_DOCUMENT_PHASE_OTP, name: 'OTP'},
            {id: self.PROPERTY_DOCUMENT_PHASE_KEY_HANDOVER, name: 'KEY HANDOVER'}
        ];

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.documents = [];
        self.file_uri = '';
        self.document_view = true;
        self.stack_view = false;

        self.selected_units_count = 0;
        self.all_units = [];
        self.temp_units_arr = [];
        self.selected_units_arr = [];
        self.units_arr_clone = [];
        self.document_editor_view = false;
        self.editor_pages = [];
        // By default first page is there
        // Increment 'editor_total_pages' in 'insertNewPage'
        self.editor_total_pages = 1;
        // Pages array index starts with 0 
        self.editor_current_page = 0;

        self.availableUnits = [];
        self.floor_types = {};
        self.floor_plan_types = [];
        self.payment_plan_ids = [];

        self.ADVANCED_OPTIONS = [];
        self.PROPERTY_OPTIONS = [];
        self.UNIT_OPTIONS = [];
        self.BUYER_OPTIONS = [];
        self.SIGNATURE_OPTIONS = [];
        self.units_master = [];
        self.filtered_units = [];
        self.unitStatuses = [];

        self.viewType = 1;
        self.offset = 1;
        self.limit = "20";
        self.current = 1;
        self.jump_to_page = 1;
        self.categories = self.SSConfigService.serverConfig.unit_categories;
        self.editableStatus = [
            self.UNIT_STATUS_DRAFT,
            self.UNIT_STATUS_LISTED,
            self.UNIT_STATUS_RESERVED,
            self.UNIT_STATUS_BOOKED,
            self.UNIT_STATUS_SOLD,
        ];
        jQuery.each(self.SSConfigService.serverConfig.unit_statuses, function (i, status) {
            if (self.editableStatus.indexOf(status.id) !== -1) {
                self.unitStatuses.push(status);
            }
        });

        self.setDocumentKindValues();
        self.getProperty();

        self.setAdvancedOptions();
        self.setPropertyOptions();
        self.setUnitOptions();
        self.setBuyerOptions();
        self.setSignatureOptions();

        self.getUnitStacks();
        self.getDeveloperUsers();
    }

    setAdvancedOptions() {
        const self = this;

        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_1',
            title: 'Date',
            type: 'date',
            label: '[Date]',
            code: "{{$current_date->format('d/m/Y')}}"
        });
    }

    setPropertyOptions() {
        const self = this;

        self.PROPERTY_OPTIONS.push({
            id: 'property_1',
            title: 'Property Name',
            type: 'text',
            label: '[Property Name]',
            code: '{{$property->name}}'
        });
    }

    setUnitOptions() {
        const self = this;

        self.UNIT_OPTIONS.push({
            id: 'unit_1',
            title: 'Unit Number',
            type: 'text',
            label: '[Unit Number]',
            code: '{{getFullUnitNumber($unit)}}'
        });
        // Images [need img tag handling]
        self.UNIT_OPTIONS.push({
            id: 'unit_2',
            title: 'Unit Floor Plan Image',
            type: 'image',
            label: '[Unit Floor Plan Image]',
            code: '<img src="{{$unitFloorplanAssetUrl}}">'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_3',
            title: 'Unit Annex A Image',
            type: 'image',
            label: '[Unit Annex A Image]',
            code: '<img src="{{$unitAnnexAAssetUrl}}">'
        });
    }

    setBuyerOptions() {
        const self = this;

        self.BUYER_OPTIONS.push({
            id: 'buyer_1',
            title: 'Buyer Identity Type',
            type: 'text',
            label: '[Buyer Identity Type]',
            code: '{{getBuyerIdentityTypeName($buyer->individual->identity_type)}}'
        });
        self.BUYER_OPTIONS.push({
            id: 'buyer_2',
            title: 'Buyer Salutation',
            type: 'text',
            label: '[Buyer Salutation]',
            code: '{{getSalutationName($buyer->individual->title)}}'
        });
        self.BUYER_OPTIONS.push({
            id: 'buyer_3',
            title: 'Buyer Name',
            type: 'text',
            label: '[Buyer Name]',
            code: '{{getUserDisplayName($broker->user)}}'
        });
        self.BUYER_OPTIONS.push({
            id: 'buyer_4',
            title: 'Buyer Gender',
            type: 'text',
            label: '[Buyer Gender]',
            code: '{{getGenderName($buyer->individual->gender)}}'
        });
        self.BUYER_OPTIONS.push({
            id: 'buyer_5',
            title: 'Buyer Nationality',
            type: 'text',
            label: '[Buyer Nationality]',
            code: '{{getNationalityName($buyer->individual->nationality)}}'
        });
        self.BUYER_OPTIONS.push({
            id: 'buyer_6',
            title: 'Buyer Marital Status',
            type: 'text',
            label: '[Buyer Marital Status]',
            code: '{{getMaritalStatusName($buyer->individual->marital_status)}}'
        });
    }

    setSignatureOptions() {
        const self = this;

        self.SIGNATURE_OPTIONS.push({
            id: 'buyer_sign_1',
            title: 'Buyer Signatures',
            type: 'text',
            label: '[Buyer Signatures]',
            code: '@{BUYER1_SIGNATURE}'
        });
        self.SIGNATURE_OPTIONS.push({
            id: 'buyer_sign_2',
            title: 'All Signatures',
            type: 'text',
            label: '[All Signatures]',
            code: '@{ALL_SIGNATURES}'
        });
    }

    getOptionById(id) {
        const self = this;

        let option = '';

        try {
            option = self.ADVANCED_OPTIONS.find(x => x.id == id);
            if (!option) {
                option = self.PROPERTY_OPTIONS.find(x => x.id == id);
            }
            if (!option) {
                option = self.SIGNATURE_OPTIONS.find(x => x.id == id);
            }
            if (!option) {
                option = self.BUYER_OPTIONS.find(x => x.id == id);
            }
            if (!option) {
                option = self.UNIT_OPTIONS.find(x => x.id == id);
            }

            return option;
        } catch (ex) {
            console.log(ex);
        }
    }

    getProperty() {
        const self = this;

        if (!self.data.property_id)
            return;

        self.property = null;
        self.propertyParams = null;

        let url = 'sec/developer/properties/' + self.data.property_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.property = response.data.property;
            self.getFloorPlans();
            self.getPaymentPlans();
            self.getPropertyDocuments();
        });
    }

    getPaymentPlans(){
        const self = this;

        let url = 'sec/developer/properties/'+ self.property.id +'/payment-plans';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if(response.data){
                self.payment_plans = response.data.payment_plans;
                if(self.payment_plans){
                    self.preparePaymentPlanTypes();
                }
            }
        });
    }

    preparePaymentPlanTypes(){
        const self = this;

        self.payment_plan_types = [];
        $.each(self.payment_plans, function(index, plan){
            self.payment_plan_types.push({ id: plan.id, name: plan.name});
        });
    }

    getPaymentPlanLabel(payment_plans) {
        const self = this;

        if (!payment_plans && !(self.payment_plans)) return '--';

        let labels = [];
        $.each(payment_plans, function (i, plan) {
            let paymentPlan = self.payment_plans.find(x => x.id == plan.payment_plan_id);
            if (paymentPlan) {
                labels.push(paymentPlan.name);
            }
        });

        return labels.length ? labels.join(', ') : '--';
    }

    getPropertyDocuments() {
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/documents';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(!self.documents){
                self.documents = []; // Initialize documents array if undefined
            }

            $.each(response.data.property_documents, function (index, document) {
                // Filter documents to prepare a list for display
                if(document.units){
                    document["selected_units"] = document.units.toLowerCase() == 'all' ? 'All' : "(" + (document.units.split(',')).length + ")";
                }
                else{
                    document["selected_units"] = 'All';
                }

                if(self.document_kinds.find(x => x.id == document.document_kind)){
                    self.documents.push(document);
                }
            });

            self.documents = _.sortBy(self.documents, 'order');
            self.applyFilters();
        });
    }

    viewSelectedUnits(units){
        const self = this;

        if(!units){
            return;
        }

        self.selected_units_list = [];
        self.selected_units_list = self.getSelectedUnitsList(units);
        
        $('#selectedUnitsViewModal').modal('show');
        self.selected_units_view = true;
    }


    getSelectedUnitsList(_units){
        const self = this;

        let units = _units.replace('UNIT_NO:', '').split(',');
        let selected_units_list = [];

        // Remove empty spaces
        units = $.map(units, function (value) {
            return value.replace(/ /g, '');
        });

        // Remove duplicates if any
        // It will throw error if already unique
        try {
            units = $.unique(units);
        } catch (ex) {
            console.log(ex);
        }

        try {
            for (var index = 0; index < units.length; index++) {
                let unit_num = units[index];
                let unitData = self.availableUnits.find(x => x.unit_num === unit_num);
                if(unitData){
                    selected_units_list.push(unitData.unit);
                }
            }
        } catch (ex) {
            console.log(ex);
        }

        return selected_units_list;
    }

    onSelectUnits(document = null) {
        const self = this;

        self.viewType = 1;
        self.units_arr_clone = [];

        // Initialize 'selectize' for floor plan filters
        self.initSelectizejs();

        // Remove previous data and initialize again
        self.removeAllUnits();

        self.initDocumentUnits(document);

        if (document) {
            //angular.copy([source], [destination]);
            if (self.selected_units_arr.length) {
                try {
                    self.selected_units_arr = _.uniq(self.selected_units_arr, 'unit_num');
                } catch (ex) {
                    console.log(ex);
                }
                angular.copy(self.selected_units_arr, self.units_arr_clone);
                self.temp_units_arr = self.selected_units_arr;
            }
        }

        self.document_view = false;
        $('#addEditDocumentModal').find('.modal-dialog').css('max-width', '990px');
        self.stack_view = true;
    }

    initDocumentUnits(document) {
        const self = this;

        self.selected_units_count = 0;
        self.selected_units_arr = [];

        if (!document) {
            self.removeAllUnits();
            return;
        }

        // Remove 'disabled' prop in order to remove/apply selection
        $('.stack-view').css("opacity", "");
        $('.stack-view :button').prop('disabled', false);

        // WEB-4277 — '' is the "every unit" convention, same as the legacy
        // 'all' keyword; both must turn Select All on and lock the picker, or
        // an all-units document loads looking like it covers zero units.
        if (!document.units || document.units.toLowerCase() == 'all') {
            self.selectAll = true;
            $('.stack-view').css("opacity", "0.5");
            $('.stack-view :button').prop('disabled', true);
        } else {

            self.selectAll = false;

            let units = document.units.replace('UNIT_NO:', '').split(',');

            // Remove empty spaces
            units = $.map(units, function (value) {
                return value.replace(/ /g, '');
            });

            // Remove duplicates if any
            // It will throw error if already unique
            try {
                units = $.unique(units);
            } catch (ex) {
                console.log(ex);
            }

            try {
                for (var index = 0; index < units.length; index++) {
                    let unit_num = units[index];
                    let unitData = self.availableUnits.find(x => x.unit_num === unit_num);
                    if (unitData) {
                        let unit = unitData.unit;
                        unit["selected"] = true;
                        unit.clickedclass = true;
                        unit.selection = 'selected';
                        self.selected_units_arr.push(unitData);
                    }
                    self.selected_units_count += 1;
                }
            } catch (ex) {
                console.log(ex);
            }
        }
    }

    onProceedUnitSelection() {
        const self = this;

        self.stack_view = false;
        $('#addEditDocumentModal').find('.modal-dialog').css('max-width', '750px');
        self.document_view = true;

        self.selected_units_arr = [];
        if (self.temp_units_arr.length) {
            try {
                self.temp_units_arr = _.uniq(self.temp_units_arr, 'unit_num');
            } catch (ex) {
                console.log(ex);
            }

            for (var index = 0; index < self.temp_units_arr.length; index++) {
                self.selected_units_arr.push(self.temp_units_arr[index]);
            }
        }
    }

    onCancelUnitSelection(document = null) {
        const self = this;

        self.initDocumentUnits(document);

        self.stack_view = false;
        $('#addEditDocumentModal').find('.modal-dialog').css('max-width', '750px');
        self.document_view = true;
    }

    toggleSelectAll() {
        const self = this;

        self.selectAll = event.target.checked;

        self.removeAllUnits();

        if (self.selected_units_count == 0) {
            if (self.selectAll) {
                $('.stack-view').css("opacity", "0.5");
                $('.stack-view :button').prop('disabled', true);
            } else {
                $('.stack-view').css("opacity", "");
                $('.stack-view :button').prop('disabled', false);
            }
        }
    }

    // onUpdateDocument(document) {
    //     const self = this;

    //     self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

    //         // Remove custom style if exists
    //         $('#addEditDocumentModal').find('.modal-dialog').css('max-width', '');
    //         self.hideModals();
    //         self.showDocumentModal = true;
    //         self.document_view = true;
    //         self.stack_view = false;
    //         self.update_document_id = document.id;

    //         self.resetErrors();
    //         self.add_document = false;
    //         self.update_document = true;

    //         self.edit_document = document;
    //         self.initializeFields(document);

    //         $('#addEditDocumentModal').modal('show');
    //     });
    // }

    // updateDocument() {
    //     const self = this;

    //     self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

    //         let url = 'sec/developer/properties/' + self.property.id + '/documents/' + self.update_document_id;

    //         // format: pdf, image, html
    //         let params = {
    //             type: self.document_kind.type,
    //             document_kind: self.document_kind.id,
    //             format: self.document_format,
    //             name: self.document_name,
    //             order: self.order,
    //             for_each_buyer: self.for_each_buyer ? 1 : 0,
    //             units: 'all'
    //         };

    //         if (self.file_uri) {
    //             params.file_uri = self.file_uri;
    //         }

    //         if (self.document_editor_view) {
    //             params.units = self.units;
    //         } else {

    //             let units = '';
    //             if (self.selectAll) {
    //                 params.units = 'all';
    //             } else if (self.selected_units_arr.length > 0) {
    //                 for (var index = 0; index < self.selected_units_arr.length; index++) {
    //                     units += self.selected_units_arr[index].unit_num + ', ';
    //                 }
    //             }

    //             if (units) {
    //                 // Remove duplicates if any
    //                 try {
    //                     units = $.unique(units);
    //                 } catch (ex) {
    //                     console.log(ex);
    //                 }
    //                 units = "UNIT_NO:" + units.substr(0, units.lastIndexOf(','));
    //                 params.units = units;
    //             }
    //         }

    //         if (!self.isValidInput()) {
    //             return;
    //         }

    //         loading(true);
    //         self.SSHttpService.putAPIRequest(url, params).then(function (response) {
    //             loading(false);
    //             self.hideModals();
    //             if (response instanceof Error) {
    //                 self.SSAlertService.parseAndDisplayError(response);
    //                 return;
    //             }

    //             self.SSAlertService.success('Success!', 'Document updated successfully');

    //             self.documents = $.grep(self.documents, function (e) {
    //                 return e.id != self.update_document_id;
    //             });

    //             self.documents.push(response.data.property_document);

    //             $.each(self.documents, function (index, document) {
    //                 if(document.units){
    //                     document["selected_units"] = document.units.toLowerCase() == 'all' ? 'All' : "(" + (document.units.split(',')).length + ")";
    //                 }
    //                 else{
    //                     document["selected_units"] = 'All';
    //                 }
    //             });

    //             self.documents = _.sortBy(self.documents, 'order');
    //         });
    //     });
    // }

    toggle_Unit_selection(unit) {
        const self = this;

        unit.clickedclass = unit.clickedclass ? false : true;
        if (unit.clickedclass) {
            unit.selection = 'selected';
            self.addUnit(unit);
        } else {
            self.checkAllUnitList = false;
            unit.selection = 'unselected';
            self.removeUnit(unit);
        }
    }

    addUnit(unit) {
        const self = this;

        self.selected_units_count += 1;
        unit["selected"] = true;
        unit.clickedclass = true;
        unit.selection = 'selected';
        let unit_num = self.getUnitNumber(unit);

        self.temp_units_arr.push({'unit_id': unit.id, 'unit_num': unit_num, 'unit': unit});
    }

    removeUnit(unit) {
        const self = this;

        self.selected_units_count -= 1;
        if (unit.hasOwnProperty("selection")) {
            unit.selection = 'unselected';
            unit.clickedclass = false;
            unit["selected"] = false;
        }

        self.temp_units_arr = $.grep(self.temp_units_arr, function (e) {
            return e.unit_id != unit.id;
        });
    }

    removeAllUnits() {
        const self = this;

        // Remove opacity and disabled property in order to remove units
        $('.stack-view').css("opacity", "");
        $('.stack-view :button').prop('disabled', false);

        for (var index = 0; index < self.all_units.length; index++) {
            let unit = self.all_units[index];
            if (unit.hasOwnProperty("selection")) {
                unit.selection = 'unselected';
                unit.clickedclass = false;
                unit["selected"] = false;
            }
        }

        if (self.selectAll) {
            self.selectAll = true;
            $('.stack-view').css("opacity", "0.5");
            $('.stack-view :button').prop('disabled', true);
        } else if (!self.selectAll) {
            self.selectAll = false;
            $('.stack-view').css("opacity", "");
            $('.stack-view :button').prop('disabled', false);
        }

        self.temp_units_arr = [];
        self.selected_units_count = 0;
    }

    removeAarrayUnits(units) {
        const self = this;

        let temp_units_count = units.length;

        for (var index = 0; index < units.length; index++) {
            let unit = units[index].unit;
            if (unit.hasOwnProperty("selection")) {
                unit.selection = 'unselected';
                unit.clickedclass = false;
                unit["selected"] = false;
            }
        }

        self.selected_units_count -= temp_units_count;
    }

    initializeSelectedUnits(document) {
        const self = this;

        self.selected_units_count = 0;
        self.selected_units_arr = [];
        self.selectAll = false;

        // WEB-4277 — '' is the "every unit" convention, same as the legacy
        // 'all' keyword; both must turn Select All on and lock the picker, or
        // an all-units document loads looking like it covers zero units.
        if (!document.units || document.units.toLowerCase() == 'all') {
            self.selectAll = true;
            $('.stack-view').css("opacity", "0.5");
            $('.stack-view :button').prop('disabled', true);
        } else if (document.units) {

            $('.stack-view').css("opacity", "");
            $('.stack-view :button').prop('disabled', false);

            let units = document.units.replace('UNIT_NO:', '').split(',');

            // Remove duplicates if any
            // It will throw error if already unique
            try {
                units = $.unique(units);
                self.selected_units_count = units.length;

                /** WEB-2469 Property Document Improvements **/
                if(units && units.length){
                    units.forEach( unit_num => {
                        let unitData = self.availableUnits.find(x => x.unit_num === unit_num.trim());
                        if (unitData) {
                            self.selected_units_arr.push(unitData.unit);
                        }
                    })
                }
            } catch (ex) {
                console.log(ex);
            }
        }

        if (document.document_kind) {
            self.$timeout(function () {
                $("select.eoi-select#documents_select").niceSelect('update');
            });
        }
    }

    onUpdateDocument(document) {
        const self = this;

        self.hideModals();

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            // Remove custom style if exists
            $('#addEditDocumentModal').find('.modal-dialog').css('max-width', '750px');

            self.showDocumentModal = true;
            self.document_view = true;
            self.stack_view = false;

            self.documentParams = {};
            self.documentErrors = {};

            self.documentParams.format = self.PROPERTY_DOCUMENT_FORMAT_HTML;

            if (document) {
                self.documentParams = angular.copy(document);
                self.documentParams.for_each_buyer = document.for_each_buyer ? true : false;
                self.documentParams.document_kind = self.getDocumentKind(document);
                self.documentParams.is_enabled = document.is_enabled ? true : false;
                self.initializeSelectedUnits(document);
            } else{
                /** WEB-2469 Property Document Improvements
                 * Clear selected unit info if new document **/
                self.selected_units_count = 0;
                self.selected_units_arr = [];
                self.selectAll = false;
            }

            self.initSelectizePaymentPlan(document);
            self.initSelectizeDeveloperSignees(document);
            self.initSelectizeAssociatedDocumentIds(document);
            self.edit_document = document;

            self.$timeout(function () {
                $("select.eoi-select#documents_select").niceSelect('update');
            });

            $('#addEditDocumentModal').modal('show');
        });
    }

    saveDocument() {
        const self = this;

        self.documentErrors = {};

        if(!self.isValidInput()){
            return;
        }

        let url = 'sec/developer/properties/' + self.property.id + '/documents';

        // type: image
        // format: pdf, html
        let params = angular.copy(self.documentParams);

        params.payment_plan_ids = params.payment_plan_ids.toString();
        params.for_each_buyer = params.for_each_buyer ? 1 : 0;
        params.document_kind = self.documentParams.document_kind.kind;
        params.type = self.documentParams.document_kind.type;
        params.is_enabled = params.is_enabled ? 1 : 0;
        params.phase_ind = self.documentParams.phase_ind;

        /** WEB-2846 AUS: DMS Documents - Developer Signing
         * Need to save Developer Signee info If
         * document type = PROPERTY_DOCUMENT_TYPE_FORM AND
         * document format = PROPERTY_DOCUMENT_FORMAT_HTML **/
        if( (params.developer_signee_user_ids && params.developer_signee_user_ids.length) &&
            self.isDeveloperSigneesFieldEnabled() ){
            // Note: developer_signee_user_ids is available from documentParams object
            params.developer_signee_user_ids = params.developer_signee_user_ids.join(",");
        } else {
            params.developer_signee_user_ids = null;
        }

        /** WEB-2979 AML/CFT Documents Changes - CDD Form D (New) **/
        if(params.associated_document_ids && params.associated_document_ids.length){
            params.associated_document_ids = params.associated_document_ids.join(",");
        } else {
            params.associated_document_ids = null;
        }

        if (self.selectAll) {
            // WEB-4277 — '' is the "every unit" convention every other row
            // follows; the server still accepts 'all' but folds it to ''
            // itself, so post the convention directly rather than the legacy
            // keyword.
            params.units = '';
        } else {
            let units = '';
            if (self.selected_units_arr && self.selected_units_arr.length > 0) {
                for (var index = 0; index < self.selected_units_arr.length; index++) {
                    units += self.selected_units_arr[index].unit_num + ', ';
                }
            }

            if (units) {
                try {
                    units = $.unique(units); // Remove duplicates if any
                } catch (ex) {
                    console.log(ex);
                }
                units = "UNIT_NO:" + units.substring(0, units.lastIndexOf(','));
                params.units = units;
            } else {
                params.units = "";
            }
        }

        if (!self.isValidInput()) {
            return;
        }

        let responseHandler = function (response) {
            loading(false);

            if (response instanceof Error) {
                // WEB-4277 — the units field can now be rejected by the server
                // (e.g. an unrecognised unit list). hideModals() used to run
                // unconditionally before this check, which closed the editor
                // and discarded everything the user had entered while showing
                // only a generic toast. Keep the editor open with the user's
                // data and surface the server's actual reason.
                self.SSAlertService.parseAndDisplayServerError(response);
                return;
            }

            self.hideModals();
            self.SSAlertService.success('Success!', 'Document updated successfully');

            self.documents = $.grep(self.documents, function (e) {
                return e.id != response.data.property_document.id;
            });
            self.documents.push(response.data.property_document);

            $.each(self.documents, function (index, document) {
                if(document.units){
                    document["selected_units"] = document.units.toLowerCase() == 'all' ? 'All' : "(" + (document.units.split(',')).length + ")";
                }
                else{
                    document["selected_units"] = 'All';
                }
            });

            self.documents = _.sortBy(self.documents, 'order');
            self.applyFilters();
        };

        loading(true);
        if (self.documentParams.id) {
            url += '/' + self.documentParams.id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    onExportDocuments() {
        const self = this;
        self.selectedDocuments = [];
        self.selectedDocuments = self.documents.map(doc => doc.id);
        $('#exportSelectedDocumentsModal').modal('show');
    }

    selectDocument(docId){
        const self = this;
        if (!self.selectedDocuments.includes(docId)) {
            self.selectedDocuments.push(docId);
        }else {
            self.selectedDocuments = self.selectedDocuments.filter(id => id !== docId);
        }
    }

    exportSelectedDocuments(){
        const self = this;
        let url = self.SSHttpService.getApiURL('sec/developer/properties/' + self.data.property.id + '/property-documents-export?document_ids='+self.selectedDocuments.join(','));
        window.open(url, '_blank');
        $('#exportSelectedDocumentsModal').modal('hide');
        self.SSAlertService.success("Success!", "Documents exported successfully");
    }

    selectAllDocuments(){
        const self = this;
        if(self.documents.length === self.selectedDocuments.length){
            self.selectedDocuments = [];
        }
        else{
            self.selectedDocuments = self.documents.map(doc => doc.id);
        }
    }


    //######

    importDocuments() {
        const self = this;

        if (!self.importParams.documentExcelFile) {
            self.SSAlertService.warning('Please select file to import.');
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function () {
                self.parseDocumentExcel(self.importParams.documentExcelFile);
            }
        );
    }


    parseDocumentExcel(file) {
        const self = this;

        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/import/property-documents/parse'),
            method: 'POST',
            data: {
                import_file: file
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);

            self.progressUploadingFiles = false;
            self.filesUploadProgress = 100;

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.importData = response.data;

            if (self.importParams.documentAssetFiles && self.importParams.documentAssetFiles.length) {
                self.uploadDocumentsFiles();
            } else {
                self._importDocuments();
            }

        }, function (response) {
            loading(false);

            self.progressUploadingFiles = false;
            self.SSAlertService.parseAndDisplayError(response);

        }, function (evt) {
        });
    }

    uploadDocumentsFiles() {
        const self = this;

        if (!self.importParams.documentAssetFiles)
            return;

        self.processedFiles = 0;
        self.totalFiles = self.importParams.documentAssetFiles.length;
        let policyUrl = 'sec/developer/properties/' + self.property.id + '/documents/s3-policy-property-document';


        self.assets = {};
        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.SSAwsService.policyAPIRequest(policyUrl, function (policy) {
            loading(false);

            self._uploadFile(policy);
        });
    }

    _uploadFile(policy, file, retryCount) {
        const self = this;

        if (!file) {
            file = self.importParams.documentAssetFiles.pop();
        }
        if (!retryCount) {
            retryCount = 0;
        }

        self.currentFileName = file.name;

        self.SSAwsService.upload(file, policy, function (response) {

            if (response instanceof Error) {
                if (retryCount < 2) {
                    // Retry
                    self._uploadFile(policy, file, retryCount + 1);
                    return;
                }

                self.SSAlertService.parseAndDisplayError(response);
            } else {
                self.SSAlertService.success('Success!', 'Assets uploaded successfully.');

                self.assets[response.config.data.file.name] = response.config.data.key;
                self.processedFiles += 1;

                self.filesUploadProgress = parseInt(100.0 * self.processedFiles / self.totalFiles);

                if (self.processedFiles == self.totalFiles) {
                    self._importDocuments();
                } else {
                    self._uploadFile(policy);
                }
            }
        });
    }

    _importDocuments() {
        const self = this;
        let importUrl = 'sec/developer/import/property-documents';

        let params = {
            property_id: self.property.id,
            documents: self.importData.property_documents,
            assets: self.assets,
            payment_plan_documents: self.importData.payment_plan_documents
        };

        loading(true);
        self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'All data is imported successfully.');

            self.progressUploadingFiles = false;
            self.showImport = false;
            self.documents = [];
            self.getPropertyDocuments();

        });
    }





    //######
    uploadDocument(files, document) {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            self._uploadDocument(files, document);
        });
    }

    _uploadDocument(files, document) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];

        let file_name = self.getFileName(file, document);
        if(!file_name){
            return;
        }

        let policyUrl = 'sec/developer/properties/' + self.property.id + '/documents/s3-policy-property-document';
        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let url = 'sec/developer/properties/' + self.property.id + '/documents/' + document.id;
            let params = document;
            params.file_uri = response.config.data.key;

            /** WEB-2469 Property Document Improvements
             * Set payment_plan_ids based on document payment_plan list **/
            let payment_plan_ids = [];
            if(document && document.payment_plan_documents && document.payment_plan_documents.length){
                $.each(document.payment_plan_documents, function(index, plan){
                    payment_plan_ids.push(plan.payment_plan_id);
                });
            }
            params.payment_plan_ids = payment_plan_ids.toString();

            // Update document
            loading(true);
            self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                loading(false);
                self.hideModals();
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.SSAlertService.success('Success!', 'Document updated successfully');

                self.documents = $.grep(self.documents, function (e) {
                    return e.id != document.id;
                });

                self.documents.push(response.data.property_document);
                self.documents = _.sortBy(self.documents, 'order');
                self.applyFilters();
            });

        }, file_name);
    }

    getFileName(file, document){
        const self = this;

        var file_name = "properties_"+ self.property.id + "_documents_" + document.id + ".";
        
        if(document.format == self.PROPERTY_DOCUMENT_FORMAT_PDF){
            if(file.type.indexOf("application/pdf") == -1){
                self.SSAlertService.danger('Error!', 'Please upload PDF file');
                return null;
            }
            else{
                file_name += "pdf";
            }
        }
        else if(document.format == self.PROPERTY_DOCUMENT_FORMAT_HTML){
            if(file.type.indexOf("html") == -1){
                self.SSAlertService.danger('Error!', 'Please upload HTML file');
                return null;
            }
            else{
                file_name += "html";
            }
        }
        else if(document.format == self.PROPERTY_DOCUMENT_FORMAT_IMG){
            if(file.type.indexOf("image") == -1){
                self.SSAlertService.danger('Error!', 'Please upload IMAGE file');
                return null;
            }
            else{
                let extension = file.name.substr((file.name.lastIndexOf('.') +1));
                file_name += extension;
            }
        }
        else{
            self.SSAlertService.danger('Error!', 'Please upload a valid document');
            return null;
        }

        return file_name; 
    }

    getUnitStacks() {
        const self = this;

        self.units = null;

        let url = 'properties/' + self.property_id + '/stacks';
        let params = {

            'return_property': true,
            'property_columns': 'id,named_id,name,type,product_type,status,location,country,region',
            'return_stack': true,
            'stack_columns': 'id,named_id,name',
            'include_units': true,
            'unit_columns': 'id,named_id,floor_no,floor_order,unit_no,unit_order,house_no,category,type,name,baths,status,price,start_price,end_price,size_ft2,psf'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.stacks = response.data.property_stacks;
            self.processServerData();
            self.getPropertyUnitTypes();

        });
    }

    processServerData() {
        const self = this;

        jQuery.each(self.stacks, function (i, stack) {
            stack.floorsData = self.SSUtilService.getFloorWiseUnits(stack.units);
            stack.availableUnits = self.filterAvailableUnits(stack.units);
        });

        // Select first stack by default
        self.selectedStackId = (self.selectedStackId) ? self.selectedStackId : self.stacks[0].id;
    }

    filterViewStack(className) {
        const self = this;

        var buttons = $("div.scroll").find("button");
        self.selected_class_name = className;

        //Make all visible
        var invisible_buttons = $("div.scroll").find("button.greyout");
        jQuery.each(invisible_buttons, function (i, button) {
            $(button).removeClass("greyout");
        });

        //Make all invisible other than className
        if (className) {
            jQuery.each(buttons, function (i, button) {
                if (!$(button).hasClass(className)) {
                    $(button).addClass("greyout");
                }
            });
        }
    }

    initSelectizejs() {
        const self = this;

        let $select = $('#selectize').selectize({
            delimiter: ',',
            persist: false,
            create: function (input) {
                return {
                    value: input,
                    text: input
                }
            }
        });
    }

    initSelectizePaymentPlan(document) {
        const self = this;

        self.clearSelectize('selectize_payment_plan');

        // Selectize documentation link: https://github.com/selectize/selectize.js/blob/master/docs/usage.md

        let payment_plan_ids = [];

        if(document && document.payment_plan_documents && document.payment_plan_documents.length > 0){
            $.each(document.payment_plan_documents, function(index, plan){
                payment_plan_ids.push(plan.payment_plan_id);
            });
        }

        self.documentParams.payment_plan_ids = angular.copy(payment_plan_ids);

        self.$timeout(function(){
            let $select = $('#selectize_payment_plan').selectize({
                valueField: 'id',
                labelField: 'name',
                sortDirection: 'desc',
                maxItems: null,
                options: self.payment_plan_types,
                items: payment_plan_ids
            });
        });
    }

    /** WEB-2846 AUS: DMS Documents - Developer Signing **/
    initSelectizeDeveloperSignees(document) {
        const self = this;

        self.clearSelectize('selectize_developer_signees');

        let developer_signee_user_ids = [];
        if (self.documentParams && self.documentParams.developer_signee_user_ids){
            developer_signee_user_ids = self.documentParams.developer_signee_user_ids
                .split(",").filter(x => x.trim().length && !isNaN(x)).map(Number);
        }
        self.documentParams.developer_signee_user_ids = angular.copy(developer_signee_user_ids);

        self.$timeout(function(){
            let $select = $('#selectize_developer_signees').selectize({
                valueField: 'id',
                labelField: 'name',
                sortDirection: 'desc',
                maxItems: null,
                options: self.developer_users,
                items: developer_signee_user_ids
            });
        });
    }

    /** WEB-2979 AML/CFT Documents Changes - CDD Form D (New) **/
    initSelectizeAssociatedDocumentIds(document) {
        const self = this;

        self.clearSelectize('selectize_associated_document_ids');

        let associated_document_ids = [];
        if (self.documentParams && self.documentParams.associated_document_ids){
            associated_document_ids = self.documentParams.associated_document_ids
                .split(",").filter(x => x.trim().length && !isNaN(x)).map(Number);
        }
        self.documentParams.associated_document_ids = angular.copy(associated_document_ids);

        let associated_doc_options = [];
        if(self.documents && self.documents.length){
            if(document && document.id){
                associated_doc_options = angular.copy(self.documents.filter(d => d.is_enabled && d.id !== document.id)); // Skip current document
            } else{
                associated_doc_options = angular.copy(self.documents.filter(d => d.is_enabled));
            }

            if(associated_document_ids){
                // Filter out deleted document's id(s)
                associated_document_ids = associated_document_ids.filter(adocId => {
                    return !!self.documents.find(d => d.id === adocId);
                })
                self.documentParams.associated_document_ids = angular.copy(associated_document_ids);
            }
        }

        self.$timeout(function(){
            let $select = $('#selectize_associated_document_ids').selectize({
                valueField: 'id',
                labelField: 'name',
                sortDirection: 'desc',
                maxItems: null,
                options: associated_doc_options,
                items: associated_document_ids
            });
        });
    }

    clearSelectize(id){
        const self = this;

        if(!id){
            return;
        }

        try{
            let selectize = $("#" + id)[0].selectize;

            if(selectize){
                selectize.destroy();
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    filterFloorPlan() {
        const self = this;

        let unit_types = self.floor_plan_type;

        if (unit_types.length > 0) {

            // Make all invisible
            var buttons = $("div.scroll").find("button");
            $(buttons).addClass("greyout");

            // Now make all visible for selected floor plan type
            for (var index = 0; index < unit_types.length; index++) {
                let type = self.floor_types[unit_types[index]];
                for (var j = 0; j < type.floor_units.length; j++) {
                    let unit = type.floor_units[j];
                    // Get unit button
                    let button = $('#' + unit.named_id)
                    if ($(button).hasClass("greyout")) {
                        $(button).removeClass("greyout");
                    }
                }
            }
        } else {
            //Make all visible
            var buttons = $("div.scroll").find("button");
            $(buttons).removeClass("greyout");
        }
    }

    getPropertyUnitTypes() {
        const self = this;

        self.propertyUnitCategories = [];

        jQuery.each(self.stacks, function (i, stack) {
            jQuery.each(stack.units, function (j, unit) {
                let category = null;
                if (unit.category in self.UNIT_CATEGORIES_MAP) {
                    category = self.UNIT_CATEGORIES_MAP[unit.category];
                } else {
                    category = self.UNIT_CATEGORIES_MAP[0];
                }

                if (self.propertyUnitCategories.indexOf(category) == -1) {
                    self.propertyUnitCategories.push(category);
                }

                // Process floor plan data
                let floor_category = unit.floor_plan;

                if (self.floor_types.hasOwnProperty(floor_category)) {

                    self.floor_types[floor_category]["floor_units"].push(unit);

                } else {

                    self.floor_types[floor_category] = {};
                    self.floor_types[floor_category]["name"] = floor_category;
                    self.floor_types[floor_category]["floor_units"] = []
                    self.floor_types[floor_category]["floor_units"].push(unit);

                    self.floor_plan_types.push({'id': unit.floor_plan, 'name': unit.floor_plan});
                }
            });
        });
    }

    getUnitCellClass(unit) {
        const self = this;

        let cls = '';

        if (!unit.category) {
            cls = 'empty';
        } else if (unit.status == self.UNIT_STATUS_LISTED) {
            if (unit.category in self.UNIT_CATEGORIES_MAP) {
                cls = self.UNIT_CATEGORIES_MAP[unit.category].className;
            } else {
                cls = self.UNIT_CATEGORIES_MAP[0].className;
            }
        } else if (unit.status == self.UNIT_STATUS_SOLD) {
            cls = 'sold';
        } else if (unit.status == self.UNIT_STATUS_DRAFT) {
            cls = 'draft';
            //cls = self.UNIT_CATEGORIES_MAP[3].className;
        } else {
            cls = 'reserved';
        }

        return cls;
    }

    filterAvailableUnits(units) {
        const self = this;

        let statuses = [self.UNIT_STATUS_LISTED, self.UNIT_STATUS_RESERVED, self.UNIT_STATUS_DRAFT, self.UNIT_STATUS_SOLD, self.UNIT_STATUS_BOOKED, self.UNIT_STATUS_SPECIAL_RESERVED];
        let filtered = [];

        _.each(units, function (unit) {
            self.all_units.push(unit);

            if (statuses.indexOf(unit.status) !== -1) {
                unit["unit_num"] = self.getUnitNumber(unit);
                let stack = self.stacks.find(x => x.id == unit.stack_id);
                if(stack){
                    unit["block_no"] = stack.name;
                }
                filtered.push(unit);
                self.availableUnits.push({'unit_id': unit.id, 'unit_num': unit.unit_num, 'unit': unit});
            }
        });

        if (self.sortBy) {
            filtered = _.sortBy(filtered, function (item) {
                return item[self.sortBy];
            })
        }

        return filtered;
    }

    getUnitNumber(unit) {
        const self = this;

        if (unit.length < 1) {
            return '-';
        }
        return self.SSUtilService.getFullUnitNumber1(unit, true);
    }

    getDocumentKindName(document) {
        const self = this;

        let name = '--';

        if(!self.document_kinds || !document){
            return name;
        }

        $.each(self.document_kinds, function(index, obj){
            if(document.document_kind == obj.kind && document.type == obj.type){
                name = obj.name;
            }
        });

        return name;
    }

    getMarketingSchemeName(id) {
        const self = this;
        let name = null;

        $.each(self.MARKETING_SCHEMES, function (i, marketingScheme) {
            if (marketingScheme.id == id) {
                name = marketingScheme.name;
                return false;
            }
        });

        return name;
    }

    getDocumentType(document) {
        const self = this;

        let documentKind = self.getDocumentKind(document);

        return documentKind ? documentKind.type : null;
    }

    getDocumentKind(document) {
        const self = this;

        let documentKind = null;

        if (self.document_kinds) {
            try {
                $.each(self.document_kinds, function(index, obj){
                    if(document.document_kind == obj.kind && document.type == obj.type){
                        documentKind = obj;
                    }
                });
            } catch (ex) {
                console.log(ex);
            }
        }

        return documentKind;
    }

    setDocumentKindValues() {
        const self = this;

        self.document_kinds = [
            {
                'id': self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM,
                'kind': self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Declaration Form - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM,
                'kind': self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Cover Letter - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER,
                'kind': self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Side Letter - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_PDI_FORM,
                'kind': self.PROPERTY_DOCUMENT_KIND_PDI_FORM,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'PDI Form - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ANNEXES,
                'kind': self.PROPERTY_DOCUMENT_KIND_ANNEXES,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Annexes Document - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ANNEX_A,
                'kind': self.PROPERTY_DOCUMENT_KIND_ANNEX_A,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Annex A - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ANNEX_B3,
                'kind': self.PROPERTY_DOCUMENT_KIND_ANNEX_B3,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Annex B3 - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ANNEX_C,
                'kind': self.PROPERTY_DOCUMENT_KIND_ANNEX_C,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Annex C - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT,
                'kind': self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Letter Of Agreement - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS,
                'kind': self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'Buyer Particulars - System Generated'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS,
                'kind': self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Purchaser Particulars Form - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_OTP,
                'kind': self.PROPERTY_DOCUMENT_KIND_OTP,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'Option To Purchase (OTP) - System Generated'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER,
                'kind': self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'Buyer Congratulations Letter - System Generated'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION,
                'kind': self.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'EOI Application - System Generated'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS,
                'kind': self.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'EOI Ballot Tickets - System Generated'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER,
                'kind': self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Selections Letter - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_LETTER,
                'kind': self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_LETTER,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'Key Handover Letter - System Generated'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM,
                'kind': self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Elite Membership Form - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_SPA_LETTER,
                'kind': self.PROPERTY_DOCUMENT_KIND_SPA_LETTER,
                'type':self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name':"SPA Letter - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ICL_BANK_IN,
                'kind': self.PROPERTY_DOCUMENT_KIND_ICL_BANK_IN,
                'type':self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name':"Inward Check List (ICL) - System Generated",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_BANK_IN_LIST,
                'kind': self.PROPERTY_DOCUMENT_KIND_BANK_IN_LIST,
                'type':self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name':"Bank In List (BIL) - System Generated",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_SALES_NOTE,
                'kind': self.PROPERTY_DOCUMENT_KIND_SALES_NOTE,
                'type':self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name':"Sales Note - System Generated",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE,
                'kind': self.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "3rd Party Payor Document - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT,
                'kind': self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "External Agent Represented - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form A1 - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form A2 - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form A3 - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_B,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_B,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form B - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_C,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_C,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form C - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_D,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_D,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form D - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_E,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_E,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form E - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': "CDD Form F",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': "CDD Form F Annexure 2",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_G,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_G,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': "CDD Form G",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORMS_CHECK,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORMS_CHECK,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Forms Check",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION,
                'kind': self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "Key Handover Collection Document - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT,
                'kind': self.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "Buyer Declaration For Self Payment - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_TAX_INVOICE,
                'kind': self.PROPERTY_DOCUMENT_KIND_TAX_INVOICE,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': "Tax Invoice",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_OFFICIAL_RECEIPT,
                'kind': self.PROPERTY_DOCUMENT_KIND_OFFICIAL_RECEIPT,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': "Official Receipt",
            },
            {
                // WEB-3524 — custom template for the GST Official Receipt (printed for GST-flagged instruments)
                'id': self.PROPERTY_DOCUMENT_KIND_OFFICIAL_RECEIPT_GST,
                'kind': self.PROPERTY_DOCUMENT_KIND_OFFICIAL_RECEIPT_GST,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': "Official Receipt (GST)",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CREDIT_NOTE,
                'kind': self.PROPERTY_DOCUMENT_KIND_CREDIT_NOTE,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': "Credit Note",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_SUBSALE_CONFIRMATION_LETTER,
                'kind': self.PROPERTY_DOCUMENT_KIND_SUBSALE_CONFIRMATION_LETTER,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': "Sub-Sales Confirmation Letter - System Generated",
            },
        ];

        self.$timeout(function () {
            $("select.eoi-select#documents_select").niceSelect('update');
        });
    }

    onDeleteDocument(document_id) {
        const self = this;

        self.hideModals();
        self.showDeleteModal = true;
        self.delete_document_id = document_id;
        $('#deleteDocumentModal').modal('show');
    }

    deleteDocument() {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            let url = 'sec/developer/properties/' + self.property_id + '/documents/' + self.delete_document_id + '/delete';
            self.hideModals();

            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.warning('Warning!', 'This document can not be deleted.');
                    return;
                }
                self.SSAlertService.success('Success!', 'Document deleted successfully');

                self.documents = $.grep(self.documents, function (e) {
                    return e.id != self.delete_document_id;
                });

                self.documents = _.sortBy(self.documents, 'order');
                self.applyFilters();
            });
        });
    }

    viewDocument(file_obj){
        const self = this;

        if (!file_obj || !file_obj.id || !file_obj.file_uri) {
            return;
        }

        if (file_obj.file_uri) {
            //Retrieve new pre-signed url to avoid timeout issue from S3
            let url = 'sec/assets/presigned-url';
            let params = {
                'model': self.ASSET_MODEL_PROPERTY_DOCUMENT,
                'id': file_obj.id
            };
            loading(true);
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                return;
                }

                window.open(response.data.presigned_url, '_blank');
            });   
        } 
        else {
            self.SSAlertService.danger("Error", "Unable to download an empty file!");
        }
    }

    downloadDocument(buyer_document) {
        const self = this;

        if (!buyer_document
            || !buyer_document.id
            || !buyer_document.file_uri
        ) {
            return;
        }

        let url = 'sec/assets/presigned-url';
        let params = {
            'model': self.ASSET_MODEL_PROPERTY_DOCUMENT,
            'id': buyer_document.id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            buyer_document.show_file_url = response.data.presigned_url;

            if (buyer_document.show_file_url) {

                let extension = buyer_document.file_uri.substr((buyer_document.file_uri.lastIndexOf('.') +1));
                let document_name = buyer_document.name + "." + extension;

                if(extension === 'html'){
                    loading(true);
                    $.get(buyer_document["show_file_url"], function (data) {
                        loading(false);

                        self.SSUtilService.saveDocumentLocal(data, document_name);
                    });
                }
                else if(extension === 'pdf'){
                    self.$window.open(buyer_document.show_file_url);
                }
                else{
                    self.SSUtilService.saveImageToLocal(buyer_document.show_file_url, document_name);
                }
            }
        });
    }

    downloadDocuments() {
        const self = this;
        window.location.href = '/developer/properties/' + self.property.named_id + '/documents/download-all';
    }

    isValidInput() {
        const self = this;

        let isValid = true;

        if (!self.documentParams.name) {
            self.documentErrors.name = 'The document name field is required.';
            isValid = false;
        }
        if (!self.documentParams.document_kind) {
            self.documentErrors.document_kind = 'The document kind field is required.';
            isValid = false;
        }
        if (!self.documentParams.payment_plan_ids.join()) {
            self.documentErrors.payment_plans = 'Please select payment plan(s)';
            isValid = false;
        }
        // if (!self.payment_plan_ids.join()) {
        //     self.error_payment_plans = 'Please select payment plan(s)';
        //     isValid = false;
        // }

        return isValid;
    }

    renderHtml(content) {
        const self = this;

        // WEB-3597 — allow-list sanitise rich text before trusting it for ng-bind-html.
        return self.sce.trustAsHtml(window.ssSanitizeHtml(content));
    }

    hideModals() {
        const self = this;

        self.showQuestiontModal = false;
        self.showDeleteModal = false;

        if ($('#addEditDocumentModal').is(':visible')) $('#addEditDocumentModal').modal('hide');
        if ($('#deleteDocumentModal').is(':visible')) $('#deleteDocumentModal').modal('hide');
    }

    get360photoClass(unit) {
        if (unit.floor_plan_3d != null) {
            return '360photo';
        }
    }

    get3DFloorPlanClass(unit) {
        if (unit.floor_plan_3d != null) {
            return '3Dfloorplan';
        }
    }

    getPhaseIndicatorLabel(phase){
        const self = this;
        if(!phase) return '--';
        return self.propertyDocumentPhaseIndicators.find(phaseIndicatorObject => phaseIndicatorObject.id == phase).name;
    }

    /** WEB-2846 AUS: DMS Documents - Developer Signing - Start **/
    getDeveloperUsers(){
        const self = this;

        let url = 'sec/developer/users/users-summary';
        let params = {
            fields: "first_name,last_name,display_name" // can also get email,phone1
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.warning('Warning!', 'Could not load developers.');
                return;
            }

            if(response && response.data && response.data.users){
                self.developer_users = response.data.users;
                if(self.developer_users && self.developer_users.length){
                    self.developer_users = self.developer_users.map(du => {
                        // Set display_name as developer name. If unavailable, join first_name and last_name into name.
                        du.name = du.display_name? du.display_name : du.first_name+' '+du.last_name;
                        return du;
                    })
                }
            }
        });
    }

    isDeveloperSigneesFieldEnabled(){
        const self = this;
        return (self.documentParams &&
            ((self.documentParams.document_kind &&
                self.documentParams.document_kind.type === self.PROPERTY_DOCUMENT_TYPE_FORM) &&
            self.documentParams.format === self.PROPERTY_DOCUMENT_FORMAT_HTML));
    }
    /** WEB-2846 AUS: DMS Documents - Developer Signing - End **/

    /** WEB-2469 Property Document Improvements - Start **/
    applyFilters(){
        const self = this;

        self.filtered_documents = self.documents.filter( document => {
            let isMatch = true;

            if(self.searchFilter && (
                document.name.toLowerCase().indexOf(self.searchFilter.toLowerCase()) === -1 &&
                self.getDocumentKindName(document).toLowerCase().indexOf(self.searchFilter.toLowerCase()) === -1)){
                isMatch = false;
            }
            if(self.kindFilter && document.document_kind !== self.kindFilter){
                isMatch = false;
            }
            if(self.typeFilter && document.type && document.type.toString() !== self.typeFilter){
                isMatch = false;
            }
            if(self.enabledFilter && document.is_enabled != self.enabledFilter){
                isMatch = false;
            }
            return isMatch;
        })
    }

    clearFilters(){
        const self = this;

        self.searchFilter = "";
        self.typeFilter = "";
        self.kindFilter = null;
        self.enabledFilter = "";

        self.applyFilters();
    }
    /** WEB-2469 Property Document Improvements - End **/

    /** WEB-3087 DMS: Improvement to UI - To link Units with documents popup - START **/
    toggleView(type){
        const self = this;

        self.viewType = type;
        self.unit_filter = {};
        self.unit_filter_enabled = false;
        let stacks = angular.copy(self.stacks);
        if (!stacks || !stacks.length) { return false; } // No unit data

        if (self.viewType === 1) {
            if (self.units_master && self.units_master.length) { // If units_master array exists
                self.units_master.forEach(unit => { // Set updated unit selection value
                    let unit_in_stack = null;
                    self.stacks.find(stack => {
                        if (stack.units && stack.units.length) { // If stack has units, find unit in stack to update
                            unit_in_stack = stack.units.find(stack_unit => stack_unit.id === unit.id);
                            return !!unit_in_stack;
                        }
                    })
                    unit_in_stack.selection = unit.selected? 'selected' : '';
                    unit_in_stack.clickedclass = unit.clickedclass;
                    unit_in_stack.selected = unit.selected;
                })
            }
        } else { // List View
            self.units_master = [];
            stacks.forEach(stack => {
                let stack_units = stack.units && stack.units.length? angular.copy(stack.units) : [];
                try{
                    $.each(stack_units, function(index, unit){
                        unit.selected = (unit.selection === 'selected');
                        unit.formatted_unit_no = self.SSUtilService.getFullUnitNumber(unit);
                    });
                    self.units_master.push(...stack_units);
                } catch (e) {
                    console.warn(e)
                }
            })

            self.units_master = self.SSUtilService.getSortedUnits(self.units_master, false, 'named_id');
            self.filtered_units = self.units_master;
            self.unitListPageChanged(1, self.filtered_units);

            // Initialize 'selectize' for floor plan filters
            self.$timeout(function () {
                self.initUnitListSelectizejs();
            });
        }
    }

    toggleCheckAllUnitList(){
        const self = this;

        if (!self.units_master || !self.filtered_units || !self.units_master.length) { return false; }

        self.temp_units_arr = [];
        if (self.checkAllUnitList && self.filtered_units.length) {
            // Check all filtered units
            self.filtered_units.forEach(unit => {
                unit.clickedclass = true;
                unit["selected"] = true;
                unit.selection = 'selected';
                let unit_num = self.getUnitNumber(unit);
                self.temp_units_arr.push({'unit_id': unit.id, 'unit_num': unit_num, 'unit': unit});
            })
        } else {
            self.filtered_units.forEach(unit => {
                unit.clickedclass = false;
                unit["selected"] = false;
                unit.selection = 'unselected';
            })
            self.selected_units_count = 0;
        }
        self.selected_units_count = self.units_master.filter(unit => unit.selected).length;
    }

    toggleUnitFilter() {
        const self = this;

        self.unit_filter = {};
        if (self.unit_filter_enabled) { // If filter togged close, reset filtered units from master array
            self.clearUnitListSelectizejs();
            self.filtered_units = self.units_master;
            self.unitListPageChanged(self.current, self.filtered_units);
        }
        self.unit_filter_enabled = !self.unit_filter_enabled;
    }

    applyUnitSearchFilter() {
        const self = this;

        if (!self.unit_filter || !self.units_master || !self.units_master.length) { return false; }

        self.filtered_units = self.units_master.filter(unit => {
            try {
                if (self.unit_filter.block_no && unit.block_no
                    && unit.block_no.toString().toUpperCase().indexOf(self.unit_filter.block_no.toUpperCase()) === -1) {
                    return false;
                }
                if (self.unit_filter.unit_no && unit.named_id
                    && ("#"+unit.named_id.toUpperCase()).indexOf(self.unit_filter.unit_no.toUpperCase()) === -1) {
                    return false;
                }
                if (self.unit_filter.floor_plan && self.unit_filter.floor_plan.length
                    && !self.unit_filter.floor_plan.find(floor_plan_id => floor_plan_id === unit.floor_plan_id)) {
                    return false;
                }
                if (self.unit_filter.category && self.unit_filter.category.length
                    && !self.unit_filter.category.find(category_id => category_id === unit.category)) {
                    return false;
                }
                if (self.unit_filter.name && unit.name
                    && unit.name.toString().toUpperCase().indexOf(self.unit_filter.name.toUpperCase()) === -1) {
                    return false;
                }
                if (self.unit_filter.status && unit.status !== self.unit_filter.status) {
                    return false;
                }
            } catch (e) {
                console.error(e);
                return false;
            }

            return true;
        })

        // Update CheckAll after filtering
        self.checkAllUnitList = (self.filtered_units.length && self.filtered_units.length === self.filtered_units.filter(unit => unit.selected).length);

        self.unitListPageChanged(self.current, self.filtered_units)
    }

    unitListPageLimitChanged() {
        const self = this;

        self.applyUnitSearchFilter()
    }

    unitListPageChanged(page, units) {
        const self = this;

        let limit = self.limit? parseInt(self.limit) : self.limit;
        if (page) {
            self.offset = limit? (page * limit) - limit : 0;
            self.current = page;
            self.jump_to_page = page;
        }

        if (!units){
            units = self.filtered_units;
        }

        if (limit){
            self.displayed_units = units.slice(self.offset, limit + self.offset);
        } else {
            self.displayed_units = units;
        }

        // SET 'CURRENT SELECTED UNITS' COUNT
        if (limit && limit < parseInt(units.length)) {
            self.displayed_units_count = limit;
        } else {
            self.displayed_units_count = units.length;
        }

        if (self.displayed_units_count === 0) {
            return;
        }

        // SET TOTAL PAGES ARRAY FOR 'JUMP TO' FEATURE
        let total_pages = Math.ceil(self.displayed_units_count / (limit || self.displayed_units_count));
        self.setTotalPagesOptions(total_pages);
    };

    setTotalPagesOptions(TOTAL_PAGES){
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for(var index = 0; index < TOTAL_PAGES; index++){
            self.TOTAL_PAGES_OPTIONS.push({id: index + 1, name: 'PAGE ' + (index + 1).toString() });
        }
    }

    getFloorPlans() {
        const self = this;

        if (!self.data.property_id) { return false; }

        let url = 'properties/' + self.data.property_id + '/floorplans';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.floorPlans = response.data.floorplans;
        });
    }

    initUnitListSelectizejs() {
        const self = this;

        //Reset selectize
        self.category_type = [];
        self.floor_plan_type = [];

        $('#selectize_category').selectize({
            delimiter: ',',
            persist: false,
            create: function (input) {
                return {
                    value: input,
                    text: input
                }
            }
        });

        $('#selectize_floor_plan').selectize({
            delimiter: ',',
            persist: false,
            create: function (input) {
                return {
                    value: input,
                    text: input
                }
            }
        });

        self.clearUnitListSelectizejs();
    }

    clearUnitListSelectizejs() {
        const self = this;

        self.$timeout(function () {
            $("#selectize_category")[0].selectize.clear();
            $("#selectize_floor_plan")[0].selectize.clear();
        });
    }
    /** WEB-3087 DMS: Improvement to UI - To link Units with documents popup - END **/
}

PropertyDocumentsController.$inject = ['$scope', '$window', '$timeout', '$sce', 'Upload', 'SSAwsService', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSConfigService', 'SSAppService', 'SSUserService', 'OTPService', 'SSDateService'];
app.controller('PropertyDocumentsController', PropertyDocumentsController);